import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Calendar, User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const News = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/news`);
      setNewsItems(response.data);
    } catch (error) {
      console.error('Error fetching news:', error);
      setNewsItems([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div className="min-h-screen bg-hermes-400 pt-20">
      {/* Logo fixe en haut à gauche */}
      <div className="fixed top-24 left-8 z-40">
        <img 
          src="/logo-quid-novi.png" 
          alt="Quid Novi" 
          className="h-20 w-20"
        />
      </div>

      {/* Hero Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6">
            Actualités
          </h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Suivez l'actualité de Quid Novi : nouvelles publications, événements, et vie de la maison d'édition.
          </p>
        </div>
      </section>

      {/* News List */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          {loading ? (
            <div className="text-center py-12">
              <p className="text-white/80">Chargement des actualités...</p>
            </div>
          ) : newsItems.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-white/80">Aucune actualité pour le moment.</p>
            </div>
          ) : (
            <div className="space-y-8">
              {newsItems.map((item) => (
                <article
                  key={item.id}
                  className="bg-white p-8 shadow-md border-l-4 border-hermes-600 hover:shadow-xl transition-shadow"
                >
                  {item.category && (
                    <span className="inline-block px-3 py-1 bg-hermes-100 text-hermes-700 text-sm font-medium mb-4">
                      {item.category}
                    </span>
                  )}
                  <h2 className="text-3xl font-serif font-bold text-stone-900 mb-4">
                    {item.title}
                  </h2>
                  <div className="flex items-center space-x-6 text-sm text-stone-600 mb-6">
                    <div className="flex items-center space-x-2">
                      <Calendar className="w-4 h-4" />
                      <span>{formatDate(item.date || item.created_at)}</span>
                    </div>
                    {item.author && (
                      <div className="flex items-center space-x-2">
                        <User className="w-4 h-4" />
                        <span>{item.author}</span>
                      </div>
                    )}
                  </div>
                  <div 
                    className="text-lg text-stone-700 leading-relaxed prose prose-stone max-w-none"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default News;